import { motion } from 'framer-motion';
import { fadeUpItem, staggerParent } from '@/animations/variants';
import { Reveal } from '@/components/ui/Reveal';
import { salonInfo } from '@/mocks/salonData';

export default function Footer() {
  return (
    <footer className="bg-soft-green border-t border-earth/20">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-12 sm:py-16">
        <Reveal
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8 mb-10 pb-10 border-b border-earth/15"
          variants={staggerParent}
        >
          {/* Brand */}
          <motion.div className="lg:col-span-1" variants={fadeUpItem}>
            <div className="flex items-center gap-2 mb-4">
              <div>
                <p className="font-serif-jp text-deep-brown font-medium text-sm">ほぐし屋さん</p>
                <p className="font-serif-jp text-earth/80 text-[10px] tracking-wider">Luminosite</p>
              </div>
            </div>

          </motion.div>

          {/* Menu links */}
          <motion.div variants={fadeUpItem}>
            <p className="font-sans-jp text-deep-brown font-semibold text-sm mb-4">Menu</p>
            <nav className="flex flex-col gap-2">
              <span className="font-sans-jp text-earth/85 text-xs">もみほぐし 90分</span>
              <span className="font-sans-jp text-earth/85 text-xs">もみほぐし + ヘッド</span>
              <span className="font-sans-jp text-earth/85 text-xs">リンパマッサージ</span>
              <span className="font-sans-jp text-earth/85 text-xs">美筋リンパマッサージ</span>
              <span className="font-sans-jp text-earth/85 text-xs">顔ツボマッサージ</span>
            </nav>
          </motion.div>

          {/* Contact */}
          <motion.div variants={fadeUpItem}>
            <p className="font-sans-jp text-deep-brown font-semibold text-sm mb-4">Contact</p>
            <div className="flex flex-col gap-2">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-forest/80 text-xs mt-0.5"></i>
                <span className="font-sans-jp text-deep-brown/85 text-xs leading-relaxed">{salonInfo.address}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-forest/80 text-xs"></i>
                <span className="font-sans-jp text-deep-brown/85 text-xs">{salonInfo.phone1}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-forest/80 text-xs"></i>
                <span className="font-sans-jp text-deep-brown/85 text-xs">{salonInfo.hours}</span>
              </div>
            </div>
          </motion.div>
        </Reveal>

        <Reveal className="text-center">
          <p className="font-sans-jp text-earth/70 text-xs">
            &copy; 2026 {salonInfo.name}. All Rights Reserved.
          </p>
        </Reveal>
      </div>
    </footer>
  );
}